import React, { useContext } from "react";
import { Button, Spinner, Table } from "react-bootstrap";
import { isValidPermission } from "../../../../services/AuthService";
import { handleFileDownload } from '../../../../utils/ComponentUtilse';
import CustomTooltip from "../../../../utils/CommonUtils";
import { ServiceContext } from "../../../../context/ServiceContext";

function Education(props) {

    const { canEditEmployee } = useContext(ServiceContext);

    const handleEdit = (id) => {
        props.setCardView({ educationEdit: true, educationId: id })
    }

    return (
        <div className="card" id="education">
            <div className="card-header d-flex justify-content-between">
                <h4 className="card-title">
                    <i className="fas fa-user-graduate font-18 align-middle me-2 text-primary"></i>
                    &nbsp; Education
                </h4>

                {canEditEmployee && isValidPermission('employee.add_employeeeducation', props.getPermissionList) &&
                    <Button
                        className="me-2 btn-sm"
                        variant="primary"
                        onClick={() => {
                            props.setCardView({ educationEdit: true });
                        }}
                    >
                        <i className="fas fa-pencil-alt"></i>&nbsp;&nbsp;Add
                    </Button>
                }
            </div>
            <div className="card-body">
                {/* <ListEmployeeEducation /> */}
                <Table responsive>
                    <thead>
                        <tr>
                            <th className="minWidth200">Degree</th>
                            <th className="minWidth200">Institution</th>
                            <th className="minWidth150">Major</th>
                            <th className="minWidth50">Year</th>
                            {isValidPermission('employee.change_employeeeducation', props.getPermissionList) &&
                                <th className="minWidth100">Action</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {props.isLoading ?
                            <tr>
                                <td style={{ textAlign: 'center' }} colSpan={5}>
                                    <Spinner animation="border" size="lg" className="me-2" />
                                </td>
                            </tr>
                            : props.employeeEducationList.length > 0
                                ? props.employeeEducationList.map((item, i) => {
                                    return (
                                        <tr>
                                            <td>{item.degree}</td>
                                            <td>{item.institution}</td>
                                            <td>{item.major}</td>
                                            <td>{item.year}</td>
                                            {canEditEmployee && isValidPermission('employee.change_employeeeducation', props.getPermissionList) &&
                                                <td>
                                                    <CustomTooltip id={`edit-${item.index}`} message="Edit">
                                                        <Button className="shadow btn-xs sharp me-1" variant='primary light' style={{ cursor: "pointer" }} onClick={() => handleEdit(item.id)}><i className="fas fa-pencil-alt"></i></Button>
                                                    </CustomTooltip>
                                                    {item.attachment_url ?
                                                        <CustomTooltip id={`download-${item.index}`} message="Download">
                                                            <Button className="shadow btn-xs sharp me-1" variant='primary light' style={{ cursor: "pointer" }} onClick={() => handleFileDownload(item.attachment_url)}><i className="fa fa-download"></i></Button>
                                                        </CustomTooltip> : null}
                                                </td>
                                            }
                                        </tr>
                                    );
                                })
                                : <tr>
                                    <td style={{ textAlign: 'center' }} colSpan={5}>No records found</td>
                                </tr>
                        }
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default Education;